import $ from 'jquery';
import { get, uniq } from 'lodash';
import { __ } from '@wordpress/i18n';

// jQuery Plugin :: Slick Carousel
import 'slick-carousel';

// Setup configure page sticky observer
import './sticky-observer';

import Configuration from './configuration';
import { imageListDOM } from './showroom-utilities';

const configureOEMPage = $('#configure-oem-container-FLP');
if (configureOEMPage.length !== 0) {
  // console.log('INITIAL: ==> ', initial);
  const $activeOptionsGroup = $('.configure-oem-group');
  const $activeCollectionGroup = $('.configure-color-oem.group-exterior_color');
  const $activeSetGroup = $('.configure-oem-group.group-exterior_color');

  const collections = {};
  let EXT_COLOR_CODE = '';
  let INT_COLOR_CODE = '';

  // setup image collections
  $('.showroom-gallery-container')
    .data('collections')
    ?.forEach((col, index) => {
      const parentIndex = index == 0 ? true : false;

      const code = col.code;

      if (parentIndex) {
        EXT_COLOR_CODE = col.code;
      }

      const baseImages = col.images;
      const sets = {};

      col.interior_colors.forEach((set, index) => {
        sets[set.code] = [...baseImages, ...set.images];
        if (parentIndex && index == 0) {
          INT_COLOR_CODE = set.code;
        }
      });

      collections[code] = sets;
    });

  runConfigSlider(EXT_COLOR_CODE, INT_COLOR_CODE);

  const initialConfig = $('.configure-main-oem').data('initial-values');
  const CONFIG = new Configuration({
    ...initialConfig,
    DOM: {
      base: $('.js-base'),
      total: $('.js-total'),
      fees: $('.js-fees'),
      options: $('.js-selected-options-group'),
      next: $('.js-oem-next'),
    },
    options: [],
  });

  $('.OptionsAccessoriesInput').on('click', function () {
    const $input = $(this).find('input');
    const optionCode = $input.data('option-code');
    const optionType = $input.attr('name');
    handleColorSlideSelection();
    handleOptionSelection($input, optionCode, optionType);
    updateNext();
  });

  function handleOptionSelection($input, optionCode, optionType) {
    if (!optionCode) {
      console.warn(__('Option code is missing!'));
      return;
    }

    let newCosts = 0;
    const newOptions = [];

    // check exterior color change
    if (optionType == 'exterior-colors') {
      const cost = $input.data('msrp');
      if (cost != 0) {
        newCosts = newCosts + cost;
        newOptions.push({
          id: $input.data('option-code'),
          primary_name: $input.data('label'),
          msrp: cost,
        });
      }
    }
    // check all remaining is-active groups and their selected options inputs
    $activeOptionsGroup.each(function () {
      const $group = $(this);
      if ($group.hasClass('is-active')) {
        $(this)
          .find('.OptionInput')
          .each(function () {
            $input = $(this);
            if ($input.prop('checked')) {
              const cost = $input.data('msrp');
              if (cost != 0) {
                newCosts = newCosts + cost;
                newOptions.push({
                  id: $input.data('option-code'),
                  primary_name: $input.data('label'),
                  msrp: cost,
                });
              }
            }
          });
      }
    });

    CONFIG.updateOptions(newOptions).updateCosts(newCosts).updateTotal().updateDOM();
  }

  function handleColorSlideSelection() {
    const codes = updatedColorCodes();
    // console.log('codes: ', codes);

    if (codes) {
      runConfigSlider(codes.collection, codes.set);
    } else {
      return false;
    }
  }

  // returns object with colleciton and set
  function updatedColorCodes() {
    let hasChanged = false;
    let collectionID = EXT_COLOR_CODE;
    let setID = INT_COLOR_CODE;

    // EXTERIOR COLOR
    $activeCollectionGroup.each(function () {
      let $color = $(this);
      let $input = $color.find('.OptionColorInput');
      if ($input.prop('checked')) {
        collectionID = $input.data('option-code');
        if (collectionID != EXT_COLOR_CODE) {
          hasChanged = true;
          EXT_COLOR_CODE = collectionID;
          // console.log('COLLECTION ==> ', collectionID);
        }
      }
    });

    // OTHER OPTIONS
    $activeSetGroup.each(function () {
      let $group = $(this);
      if ($group.hasClass('is-active')) {
        $group.find('.OptionInput').each(function () {
          let $input = $(this);
          if ($input.prop('checked')) {
            // console.log($input);
            setID = $input.data('option-code');
            if (setID != INT_COLOR_CODE) {
              hasChanged = true;
              INT_COLOR_CODE = setID;
              // console.log('SET ==> ', setID);
            }
          }
        });
      }
    });

    // console.log(hasChanged, setID, collectionID);
    return hasChanged ? { collection: collectionID, set: setID } : false;
  }

  // handles updating
  function updateNext() {
    const base = `/build/summary/${CONFIG.id}`;

    const params = new URLSearchParams({
      selected_options: EXT_COLOR_CODE === INT_COLOR_CODE ? EXT_COLOR_CODE : INT_COLOR_CODE,
      refNum: CONFIG.refNum,
    });

    CONFIG.updateNext(`${base}?${params.toString()}`);
  }

  function runConfigSlider(collection, set) {
    const imageCollection = get(collections, collection);
    if (!imageCollection) {
      return;
    }

    let sliderID = collection + '-' + set;

    $('.collection-oem-slider').each(function () {
      $(this).removeClass('is-active');
    });

    $('.collection-oem-controls').each(function () {
      $(this).removeClass('is-active');
    });

    const $configureGallerySlider = $(`.slider-${sliderID}`);

    if (!$configureGallerySlider.hasClass('slick-initialized')) {
      const images = get(imageCollection, set);

      $configureGallerySlider.empty();

      images?.forEach((img, index) => {
        $configureGallerySlider.append(imageListDOM({ src: img }, index, sliderID));
      });

      $configureGallerySlider.on('init', function (event, slick) {
        if (slick.$dots) {
          const dots = slick.$dots.find('li');
          const theme = $(`.controls-dots-${sliderID}`).data('theme');
          dots.addClass('slick-dot ' + theme);
        }
      });

      $configureGallerySlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        appendDots: $(`.controls-dots-${sliderID}`),
        nextArrow: $(`.controls-next-${sliderID}`),
        prevArrow: $(`.controls-prev-${sliderID}`),
      });
    }

    $configureGallerySlider.on('setPosition', function (e, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });

    $configureGallerySlider.addClass('is-active');
    $(`.controls-${sliderID}`).addClass('is-active');
  }
}
